import WebsitePoco from './poco.json';
import GolanPoco from './golanPoco.json';

export const getWebsite = (staticWebSiteUrl, startPageBlock, guidValue) => {
  /*  let website;
  if (staticWebSiteUrl.includes('golan')) {
    website = GolanPoco;
  } else {
    website = WebsitePoco;
  }
  website[0].contentRoots.startPage == { ...website[0].contentRoots.startPage, id: startPageBlock };
  return website; */
  const thisWebsite = WebsitePoco.filter((item) => item.id === guidValue);
  return thisWebsite;
};
/*
"startPage": {
        "id": 43287,
        "workId": 0,
        "guidValue": "2a30930b-7f35-4c52-b7a8-9ceeffb5dc38",
        "providerName": null,
        "url": "/",
        "expanded": null
      }

*/
